module.exports = __webpack_public_path__ + "static/img/2.5135cd99.jpg";